import React from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
  Badge,
} from "antd";

import { ReactComponent as Visa } from "../assets/images/visa.svg";
import { ReactComponent as Hotel } from "../assets/images/hotel.svg";
import { ReactComponent as BreakFast } from "../assets/images/breakFast.svg";
import { ReactComponent as Transport } from "../assets/images/transport.svg";
import { Input } from "antd";
import activitiesImg from "../assets/images/activities.jpg";
import crazyDealImg from "../assets/images/crazyDeals.jpg";
import hotelImg from "../assets/images/hotel.jpg";
import holidayImg from "../assets/images/holiday.jpg";
import visaImg from "../assets/images/visa.jpg";
import cruiseImg from "../assets/images/cruise.jpg";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import exploreCountryImg from "../assets/images/visaCardImg1.jpg";
import exploreCountryTwoImg from "../assets/images/visaCardImg2.jpg";
import exploreCountryThreeImg from "../assets/images/visaCardImg3.jpg";
import exploreCountryFourImg from "../assets/images/visaCardImg4.jpg";
import sliderImg from "../assets/images/bannerHotel.jpg";
import { ReactComponent as CheckOutlinedCustom } from "../assets/images/checkbox-icon.svg";
import { ReactComponent as Accommodation } from "../assets/images/accommodation.svg";
import { ReactComponent as AllMeals } from "../assets/images/all-meals.svg";
import { ReactComponent as OnTourTransport } from "../assets/images/On-tour transport.svg";
import { ReactComponent as BestValueItinerary } from "../assets/images/best-value-itinerary.svg";
import { ReactComponent as TourManagers } from "../assets/images/tour-managers.svg";
import cruiseIcon from "../assets/images/cruiseIcon.svg";
import cruiseImgOne from "../assets/images/visaOffers1.jpg";
import cruiseImgTwo from "../assets/images/visaOffers2.jpg";
import cruiseImgThree from "../assets/images/visaOffers3.jpg";

import {
  GiftOutlined,
  DollarOutlined,
  HomeOutlined,
  CompassOutlined,
  FileDoneOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import MegaMenu from "../components/MegaMenu";
import HotelSearchForm from "../components/HotelSearchForm";
import HotelSearchUI from "../components/HotelSearchForm";
import ExplorePlaces from "../components/ExplorePlaces";
import ReviewSlider from "../components/ReviewSlider";
import CruiseSearch from "../components/CruiseSearch";
import ExploreAttractions from "../components/ExploreAttractions";
import VisaSearch from "../components/VisaSearch";
import VisaDetailSearch from "../components/VisaDetailSearch";
import VisaOptionsCard from "../components/VisaOptionsCard";
import VisaDetailTabs from "../components/VisaDetailTabs";
import FAQAccordion from "../components/FAQAccordion";

const { Text, Paragraph } = Typography;
const categories = [
  {
    title: "Activities",
    desc: "your wanderlust awaits!",
    icon: <GiftOutlined />,
    img: activitiesImg,
  },
  {
    title: "Crazy Deals",
    desc: "Deal on Hotel and Flights",
    icon: <DollarOutlined />,
    img: crazyDealImg,
  },
  {
    title: "Hotel",
    desc: "your wanderlust awaits!",
    icon: <HomeOutlined />,
    img: hotelImg,
  },
  {
    title: "Holiday",
    desc: "your wanderlust awaits!",
    icon: <CompassOutlined />,
    img: holidayImg,
  },
  {
    title: "Visa",
    desc: "your wanderlust awaits!",
    icon: <FileDoneOutlined />,
    img: visaImg,
  },
  {
    title: "Cruise",
    desc: "your wanderlust awaits!",
    icon: <RocketOutlined />,
    img: cruiseImg,
  },
];

const offers = [
  {
    img: cruiseImgOne,
    title: "United Arab Emirates",
    desc: "Get up to $200 extra to spend at sea on",
    visaProcessed: "100k+ Visas Processed",
    price: "₹ 6,600",
    serviceFee: "+ ₹ 590",
  },
  {
    img: cruiseImgTwo,
    title: "Thailand",
    desc: "Get up to $200 extra to spend at sea on",
    visaProcessed: "100k+ Visas Processed",
    price: "₹ 6,600",
    serviceFee: "+ ₹ 590",
  },
  {
    img: cruiseImgThree,
    title: "Vietnam",
    desc: "Get up to $200 extra to spend at sea on",
    visaProcessed: "100k+ Visas Processed",
    price: "₹ 6,600",
    serviceFee: "+ ₹ 590",
  },
];

const tours = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
];

const cruisePack = [
  {
    id: 1,
    image: exploreCountryImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    title: "Canada Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    title: "China Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 4,
    image: exploreCountryFourImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 5,
    image: exploreCountryImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 6,
    image: exploreCountryTwoImg,
    title: "Canada Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 7,
    image: exploreCountryThreeImg,
    title: "China Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 8,
    image: exploreCountryFourImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 9,
    image: exploreCountryImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 10,
    image: exploreCountryTwoImg,
    title: "Canada Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 11,
    image: exploreCountryThreeImg,
    title: "China Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
  {
    id: 12,
    image: exploreCountryFourImg,
    title: "Australia Visa",
    detail:
      "Celestyal Discovery, operated by Celestyal Cruises, offers an all-inclusive.",
  },
];

const highlights = [
  "Singapore and Bali Honeymoon Bliss | City Romance to Tropical Retreat",
  "Best Of Singapore | FREE Universal Studio Tickets Singapore & Malaysia Trip | FREE Night Safari Experience",
];

const toursForYou = [
  {
    title: "Best Selling UAE Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "International Tourist Visas",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Cruise Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Best Selling Singapore Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
];

const inclusiveTours = [
  {
    icon: <Accommodation />,
    title: "Accommodation",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <AllMeals />,
    title: "All meals",
    description: "Eat to your heart's content Breakfast. Lunch. Dinner.",
  },
  {
    icon: <OnTourTransport />,
    title: "On-tour transport",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <BestValueItinerary />,
    title: "Best value itinerary",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <TourManagers />,
    title: "Tour managers",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
];

const RibbonBadge = () => {
  return (
    <div class="ribbon">
      <span class="ribbon-text"> ★ 4.9 (523)</span>
    </div>
  );
};

const { Search } = Input;
const VisaDetailPage = () => {
  return (
    <>
      <section>
        <VisaDetailSearch />
      </section>

      <section className="py-6 pt-10">
        <VisaOptionsCard />
      </section>

      <section className="p-6 mt-8">
        <div className="container">
          {/* Header */}

          <div className="flex justify-between align-middle items-center mb-4">
            <h2 className="font-medium text-danger">
              <span className="text-primary"> Best-Loved </span> Countries for
              Travelers
            </h2>
          </div>

          {/* Cards */}
          <Row gutter={[16, 16]}>
            {offers.map((offer, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <Card
                  className="flex rounded-[20px] overflow-hidden border-[#E5E5E5]"
                  styles={{
                    body: {
                      padding: "0px",
                      flex: "1",
                    },
                  }}
                >
                  <div className="flex">
                    {/* Left image with half-oval */}
                    <div className="relative w-[45%] overflow-hidden rounded-r-full">
                      <div className="absolute overflow-hidden rounded-r-full bg-black/10 w-[95%] h-[100%] "></div>
                      <img
                        src={offer.img}
                        alt={offer.title}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Right content */}
                    <div className="w-[55%] p-5 pl-4 pr-2 flex flex-col justify-center">
                      <h3 className="text-base mb-2 font-medium">
                        {offer.title}
                      </h3>
                      <Paragraph className="text-xs mb-4 font-medium">
                        {offer.desc}
                      </Paragraph>
                      <Paragraph className="text-xs mb-4 font-medium">
                        {offer.visaProcessed}
                      </Paragraph>

                      <Paragraph className="text-base text-primary !mb-1 font-semibold">
                        {offer.price}{" "}
                        <span className="text-[#0D0D0D]/60 font-medium text-xs">
                          per adult
                        </span>
                      </Paragraph>

                      <Paragraph className="text-[#0D0D0D]/60 font-medium text-xs">
                        {offer.serviceFee} <span>service fees</span>
                      </Paragraph>

                      <Button
                        type="danger"
                        size="middle"
                        className="mt-2 text-xs rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] 
                        bg-danger hover:bg-red-700 border-none rounded-md px-4 py-2 text-white w-fit"
                      >
                        View Details
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="py-6">
        <VisaDetailTabs />
      </section>

      <section className="py-6">
        <ReviewSlider />
      </section>
      <section className="py-6">
        <FAQAccordion />
      </section>
    </>
  );
};

export default VisaDetailPage;
